import { r as registerInstance, h, H as Host } from './index-5faac9d7.js';
import { t as tryParse } from './index-39f51a91.js';
import { B as Brand } from './types-66e6568b.js';
import { g as getContextDirection } from './contextDirection-33f260e3.js';
import './currency-49e0d692.js';
import './_commonjsHelpers-7db8bc26.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_nodeUtil-549406aa.js';
import './_Stack-cf94d4e7.js';
import './types-e54f4a51.js';

const SEProductDatasheet = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.seProductsAll = undefined;
    this.sePdfEpds = undefined;
    this.sePdsAdditionalData = undefined;
    this.seContextDirection = undefined;
    this._seProductsAll = undefined;
    this._sePdfEpds = undefined;
    this._sePdsAdditionalData = undefined;
  }
  componentWillLoad() {
    var _a, _b, _c;
    this.seProductsAll = (_a = tryParse(this._seProductsAll)) !== null && _a !== void 0 ? _a : this.seProductsAll;
    this.sePdfEpds = (_b = tryParse(this._sePdfEpds)) !== null && _b !== void 0 ? _b : this.sePdfEpds;
    this.sePdsAdditionalData = (_c = tryParse(this._sePdsAdditionalData)) !== null && _c !== void 0 ? _c : this.sePdsAdditionalData;
  }
  render() {
    var _a;
    if (!this.seProductsAll)
      return null;
    const { productInfo, productCR, productMedia, highlightedCharacteristics, ctaArea, productStatus, co2message, } = this.seProductsAll.base;
    const { characteristicTables, productCharacteristicsLabel, } = this.seProductsAll.specifications || {};
    const { sustainability, environmentalData, dataSheetDate, dataSheetTitle, dataSheetDisclaimer, dataSheetPriceLabel, specifications, } = this.seProductsAll;
    const { greenPremiumLogo } = this.seProductsAll.base.sustainability || {};
    const configDirection = (_a = this.seProductsAll.config) === null || _a === void 0 ? void 0 : _a.direction;
    this.seContextDirection = getContextDirection(configDirection);
    const { pdfIcons } = this.sePdsAdditionalData;
    return (h(Host, null, h("pes-product-datasheet", { showHeader: true, showDisclaimer: true, showWeeePriceLabel: true, specifications: specifications, sustainability: sustainability, environmentalData: environmentalData, date: dataSheetDate, title: dataSheetTitle, disclaimer: dataSheetDisclaimer, priceLabel: dataSheetPriceLabel, productInfo: productInfo, productCr: productCR, productMedia: productMedia, highlightedCharacteristics: highlightedCharacteristics, ctaArea: ctaArea, subtitle: productCharacteristicsLabel, characteristicTables: characteristicTables || [], greenPremiumLogo: greenPremiumLogo, pdfEpds: this.sePdfEpds, productStatus: productStatus, brand: Brand.se, contextDirection: this.seContextDirection, pdfIcons: pdfIcons, co2message: co2message })));
  }
};

export { SEProductDatasheet as pes_se_product_datasheet };
